import Lifts from './Lifts'

export default Lifts
